const faqData = [
  {
    q: '吃瓜视频在线观看需要下载软件吗？',
    a: '完全不需要！吃瓜视频在线观看是纯网页端平台，打开浏览器即可在线观看51吃瓜、91吃瓜、黑料吃瓜等全部视频内容，支持手机、平板、电脑多端访问，即点即看，无需下载安装任何软件或插件。',
  },
  {
    q: '视频播放会不会卡顿？画质怎么样？',
    a: '平台采用先进的视频分发技术，自适应带宽提供最佳画质。51吃瓜和91吃瓜视频均支持高清流畅播放，在网络正常的情况下几乎无缓冲等待。我们持续优化服务器性能，确保99.9%的在线可用率。',
  },
  {
    q: '平台视频内容多久更新一次？',
    a: '我们的编辑团队全天候追踪全网热点，51吃瓜、91吃瓜、黑料吃瓜等内容每日不间断更新。重大热点事件发生后，相关视频最快可在30分钟内上线，确保你第一时间获取最新吃瓜资讯。',
  },
  {
    q: '黑料吃瓜在线观看收费吗？',
    a: '所有视频内容均免费观看，无需会员、无需付费。我们通过广告合作维持平台运营，为你提供完全免费的51吃瓜在线观看、91在线吃瓜和黑料吃瓜点播服务，且广告不影响观看体验。',
  },
  {
    q: '如何向我们投稿爆料？',
    a: '欢迎通过投稿邮箱 tougao@chigua.news 或微信公众号「吃瓜视频客服」向我们提供独家吃瓜素材。投稿内容经编辑审核通过后，将在24小时内上线展示，优质投稿作者还可获得专属标识。',
  },
  {
    q: '平台上的内容是否经过核实？',
    a: '我们设有专业的内容审核团队，对所有上线的51吃瓜、91吃瓜和黑料吃瓜内容进行多轮核实。对于尚在发酵中的事件会标注「持续跟进」标签，对于已确认的虚假信息会第一时间下架并发布澄清说明，保障你的吃瓜体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3 justify-center">
          <div className="w-8 h-8 rounded-lg bg-secondary-500 flex items-center justify-center">
            <i className="ri-question-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 text-center">关于51吃瓜、91吃瓜在线观看的常见疑问解答</p>

        <div className="space-y-4">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="font-heading font-bold text-foreground-900 text-base md:text-lg mb-3">
                <span className="text-primary-500 mr-2">Q{i + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}